import React, { useState } from "react";
import { useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import "../../../../imageUrl";
import AuthUser from "../../../../Components/AuthUser";
import { useContext } from "react";
import { memberContext } from "../../../../navbar/auth";
import "./CurrentStock.css";
import Select from "react-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@mui/material";
import stockFile from "../../../../front_assets/sample_file/stocks.csv";

import { toast } from "react-toastify";

const CurrentStock = () => {
  const { http } = AuthUser();

  const [row_data_list, setRowDataList] = useState([]);
  const [stateupdate, setstateupdate] = useState();
  const [data, setData] = useState([]);
  const { cart, setCart } = useContext(memberContext);

  const [spinner, setSpinner] = useState(true);
  const [brand, setBrand] = useState([]);
  // newStock

  useEffect(() => {
    const controller = new AbortController();
    http.get(`/current-stock`, { signal: controller.signal }).then((res) => {
      setSpinner(false);
      if (res.status === 200) {
        console.log(res);
        setRowDataList(res.data);
        setData(res.data);
      }
    });
    http.get(`/brand`, { signal: controller.signal }).then((res) => {
      setBrand(res.data.data);
    });

    return () => controller.abort();
  }, [stateupdate]);

  const handleFilter = (e) => {
    if (parseInt(e.target.value) === 1) {
      setRowDataList(data);
    } else if (parseInt(e.target.value) === 2) {
      const available_stock = data.filter((d) => d.stock && d.stock > 0);
      setRowDataList(available_stock);
    } else if (parseInt(e.target.value) === 6) {
      const reOrder = data.filter((d) => d.stock < 20 && d.stock > 1);

      setRowDataList(reOrder);
    }
  };

  const handleBrand = (item) => {
    console.log(item.id);
    const stock = data.filter((d) => d.manufacturer == item.title);
    setRowDataList(stock);
  };

  const columns = [
    {
      title: "SL",
      field: "",
      render: (row) => <div>{row.tableData.id + 1}</div>,

      cellStyle: {
        textAlign: "center",
        width: "2%",
      },
    },

    {
      title: "Name",
      field: `name`,
      cellStyle: {
        // whiteSpace: 'nowrap',
        textAlign: "center",
      },
    },

    {
      title: "Manufacturer",
      field: `manufacturer`,
      render: (row) => <div className="text-center">{row.manufacturer}</div>,
      cellStyle: {
        // whiteSpace: 'nowrap',
        width: "15%",
        textAlign: "center",
      },
    },

    {
      title: "Box Type",
      field: `box_type`,
      render: (row) => <div className="text-center">{row.box_type}</div>,
      cellStyle: {
        // width: "6%",
        textAlign: "center",
      },
    },
    {
      title: "Pkt Size",
      field: `pkt_size`,
      cellStyle: {
        textAlign: "center",
      },
    },

    {
      title: "No of Box",
      render: (row) => {
        const stock = parseFloat(row.stock || 0);
        const pktSize = parseFloat(row.pkt_size || 0);
        const result = pktSize > 0 ? (stock / pktSize).toFixed(2) : "0";
        return <p className="text-center">{result}</p>;
      },
    },
    {
      title: "Store In",
      render: (row) => (
        <p className="text-center">
          {row.store_in.length > 0
            ? row.store_in.reduce((a, b) => a + parseInt(b.total_qty || 0), 0)
            : 0}
        </p>
      ),
    },
    {
      title: "Sales Return",
      render: (row) => (
        <p className="text-center">
          {row.sales_return.length > 0
            ? row.sales_return.reduce((a, b) => a + parseInt(b.pcs || 0), 0)
            : 0}
        </p>
      ),
    },
    {
      title: "Adjustment",
      render: (row) => (
        <p className="text-center">
          {row.adjustment.length > 0
            ? row.adjustment.reduce(
                (a, b) => a + parseInt(b.increase || 0),
                0
              ) -
              row.adjustment.reduce((a, b) => a + parseInt(b.decrease || 0), 0)
            : 0}
        </p>
      ),
    },
    {
      title: "Stock Out",
      render: (row) => (
        // <p>{row.stock_out_sum_pcs ? row.stock_out_sum_pcs : 0}</p>
        <p className="text-center">
          {row.stock_out.length > 0
            ? row.stock_out.reduce((a, b) => a + parseInt(b.pcs || 0), 0)
            : 0}
        </p>
      ),
    },
    {
      title: "Stock",
      render: (row) => <p className="text-center">{row.stock || 0}</p>,
      cellStyle: {
        textAlign: "center",
        fontWeight: "bold",
        color: "red",
      },
    },
    {
      title: "Bonus Qty",
      field: `bonus_qty`,
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Unit",
      field: `unit`,

      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "MRP",
      field: `unit`,
      render: (row) => {
        console.log(row);
        return (
          <div className="text-center">
            {parseFloat(row?.drug?.mrp_per_pcs_price) > 0
              ? row?.drug?.mrp_per_pcs_price
              : 0}
          </div>
        );
      },
    },
    {
      title: "PP",
      field: `unit`,
      render: (row) => {
        return <>{parseFloat(row.drug?.drug_price || 0).toFixed(2)}</>;
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Vat",
      field: `unit`,
      render: (row) => (
        <>{parseFloat(row.drug?.vat ? row.drug?.vat : 0).toFixed(2)}</>
      ),
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Total Price",
      field: `unit`,
      render: (row) => (
        <>
          {(
            (parseFloat(row.drug?.drug_price) +
              parseFloat(row.drug?.vat ? row.drug?.vat : 0)) *
              parseInt(row.stock) -
            (parseFloat(row.drug?.drug_price) +
              parseFloat(row.drug?.vat ? row.drug?.vat : 0)) *
              parseInt(row.bonus_qty)
          ).toFixed(2)}
        </>
      ),

      cellStyle: {
        textAlign: "center",
      },
    },
  ];

  const [open, setOpen] = useState(false);
  const [csvFile, setcsvFile] = useState(null);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      setcsvFile(null);
    }
  };
  const totalPrice = row_data_list
    .reduce(
      (a, b) =>
        a +
        parseInt(b.stock) *
          parseFloat(b.drug?.drug_price ? b.drug?.drug_price : 0).toFixed(2),
      0
    )
    .toFixed(2);
  const totalMRPPrice = row_data_list
    .reduce(
      (a, b) =>
        a +
        parseInt(b.stock) *
          parseFloat(b.drug?.mrp_per_pcs_price ? b.drug?.mrp_per_pcs_price : 0),
      0
    )
    .toFixed(2);
  const total = row_data_list.reduce((a, b) => a + parseInt(b.stock || 0), 0);

  const handleDownLoadXLSX = (data) => {
    const formattedData = data?.map((item) => ({
      SL: item.tableData.id + 1,
      Name: item.name ? item.name : "",
      Manufacturer: item.manufacturer ? item.manufacturer : "",
      "Box Type": item.box_type ? item.box_type : "",
      "Pkt Size": item.pkt_size ? item.pkt_size : "",
      "No of Box":
        item.pkt_size > 0 && item.stock
          ? (item.stock / item.pkt_size).toFixed(2)
          : "0",
      "Store In":
        item.store_in.length > 0
          ? item.store_in.reduce((a, b) => a + parseInt(b.total_qty || 0), 0)
          : 0,
      "Sales Return":
        item.sales_return.length > 0
          ? item.sales_return.reduce((a, b) => a + parseInt(b.pcs || 0), 0)
          : 0,
      Adjustment:
        item.adjustment.length > 0
          ? item.adjustment.reduce((a, b) => a + parseInt(b.increase || 0), 0) -
            item.adjustment.reduce((a, b) => a + parseInt(b.decrease || 0), 0)
          : 0,
      "Stock Out":
        item.stock_out.length > 0
          ? item.stock_out.reduce((a, b) => a + parseInt(b.pcs || 0), 0)
          : 0,
      Stock: item.stock ? item.stock : 0,
      "Bonus Qty": item.bonus_qty ? item.bonus_qty : 0,
      Unit: item.unit ? item.unit : "",
      MRP:
        parseFloat(item.drug?.mrp_per_pcs_price) > 0
          ? item.drug?.mrp_per_pcs_price
          : 0,
      PP: parseFloat(item.drug?.drug_price || 0).toFixed(2),
      Vat: parseFloat(item.drug?.vat ? item.drug?.vat : 0).toFixed(2),
      "Total Price": (
        (parseFloat(item.drug?.drug_price) +
          parseFloat(item.drug?.vat ? item.drug?.vat : 0)) *
          parseInt(item.stock) -
        (parseFloat(item.drug?.drug_price) +
          parseFloat(item.drug?.vat ? item.drug?.vat : 0)) *
          parseInt(item.bonus_qty)
      ).toFixed(2),
    }));
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Current Stock");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const fileName = "current_stock.xlsx";
    saveAs(blob, fileName);
  };
  return (
    <div className="page-content">
      <div className="custom-card patients-head  ">
        <h5 className="fw-normal custom_py-3 px-2 text-start mb-2 card-title">
          Current Stock
        </h5>
      </div>

      <div className="custom-card patients-head mb-2 p-2">
        <div className="row gx-3">
          <div className="col-2">
            <select
              onChange={(e) => handleFilter(e)}
              className="form-select form-select-sm"
              aria-label=".form-select-sm example"
            >
              <option value="1" selected>
                All
              </option>
              <option value="2">Available</option>
              <option value="6" name="reorder">
                Reorder
              </option>
            </select>
          </div>
          <div className="col-3">
            <Select
              options={brand}
              onChange={(e) => handleBrand(e)}
              getOptionLabel={(brandName) => `${brandName.title}`}
              getOptionValue={(brandName) => `${brandName.id}`}
            />
          </div>

          <div className="col-7 d-flex justify-content-end">
            <a href={stockFile} download>
              <button
                style={{ background: "#69b128", color: "white" }}
                type="button"
                className="btn btn-sm mt-1 me-1"
              >
                <i class="fa fa-download" aria-hidden="true"></i> Sample file
              </button>
            </a>

            <button
              style={{ background: "#69b128", color: "white" }}
              type="button"
              className="btn btn-sm mt-1 me-1"
              onClick={() => setOpen(true)}
            >
              <i class="fa fa-upload" aria-hidden="true"></i> CSV
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 grid-margin stock-table">
          <div>
            <div>
              <MaterialTable
                columns={columns}
                data={row_data_list}
                isLoading={spinner ? true : false}
                components={{
                  Toolbar: (props) => (
                    <div className="d-flex justify-content-between align-items-center">
                      <MTableToolbar {...props} />
                      <button
                        style={{ background: "#69b128", color: "white" }}
                        type="button"
                        className="btn btn-sm mt-1 me-1"
                        disabled={row_data_list.length === 0}
                        onClick={() => handleDownLoadXLSX(row_data_list)}
                      >
                        <i class="fa fa-download" aria-hidden="true"></i>{" "}
                        Download Current Stock
                      </button>
                    </div>
                  ),
                }}
                options={{
                  selection: false,
                  search: true,
                  showTitle: false,
                  searchFieldAlignment: "left",
                  pageSize: 10,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [5, 10, 20, 50, 100],
                  rowStyle: {
                    fontSize: ".75rem",
                    textAlign: "center",
                  },
                  headerStyle: {
                    fontSize: ".75rem",
                    border: "1px solid #c9c9c9",
                    textAlign: "center",
                    zIndex: "0",
                    whiteSpace: "nowrap",
                  },
                }}
                style={{ overflowX: "auto" }}
                onSelectionChange={(rows) => setCart(rows)}
              />
            </div>
            <div className="d-flex mt-2">
              <h6 className="mb-2 me-3">Total Stock Quantity : {total} </h6>
              <h6 className="me-3">Total Purchase Price : {totalPrice}</h6>
              <h6 className="me-3">Total MRP Price : {totalMRPPrice}</h6>
            </div>
          </div>
        </div>
      </div>

      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle sx={{ fontSize: "15px" }}>Import Data</DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <FormControl sx={{ m: 1, minWidth: 150, padding: 0 }}>
            <input
              onChange={(e) => {
                setcsvFile(e.target.files[0]);
              }}
              type="file"
              className="ms-2"
              accept=".csv"
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={() => {
              if (csvFile !== null) {
                var formdata = new FormData();
                formdata.append("file", csvFile);

                http
                  .post("/stock-in-by-csv", formdata)
                  .then((res) => {
                    toast.success(res.data.message);
                    setstateupdate(Math.random());
                    handleClose();
                  })
                  .catch((err) => {
                    if (err.response.data.error !== undefined) {
                      toast.error(err.response.data.error);
                    } else if (err.response.data.name !== undefined) {
                      toast.error(err.response.data.name[0]);
                    } else if (err.response.data.price !== undefined) {
                      toast.error(err.response.data.price[0]);
                    } else if (err.response.data.stock !== undefined) {
                      toast.error(err.response.data.stock[0]);
                    } else if (err.response.data.manufacturer !== undefined) {
                      toast.error(err.response.data.manufacturer[0]);
                    } else if (err.response.data.drug_id !== undefined) {
                      toast.error(err.response.data.drug_id[0]);
                    } else if (err.response.data.pkt_size !== undefined) {
                      toast.error(err.response.data.pkt_size[0]);
                    } else if (err.response.data.box_type !== undefined) {
                      toast.error(err.response.data.box_type[0]);
                    } else if (err.response.data.unit !== undefined) {
                      toast.error(err.response.data.unit[0]);
                    } else if (err.response.data.rack !== undefined) {
                      toast.error(err.response.data.rack[0]);
                    } else if (err.response.data.shelf !== undefined) {
                      toast.error(err.response.data.shelf[0]);
                    } else if (err.response.data.expire_date !== undefined) {
                      toast.error(err.response.data.expire_date[0]);
                    } else {
                      toast.error("Opps Something is wrong !");
                    }
                    handleClose();
                  });
              } else {
                toast.warning("please select file");
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CurrentStock;
